/* eslint-disable react-func/max-lines-per-function */
import { EChartsOption } from 'echarts';
import { px2vw } from '@/utils';
import { MassageType2Text } from '@/constant';
import { formatDay } from '../StatisticsInfo/echartsOption';
import { klona } from 'klona';

const BACKGROUND_COLOR_TOOLTIP_BY_MASSAGE: Record<Massage.MassageItem, string> = {
  Shockwave: '#E6F2FF',
  Massage: '#F1ECFF',
  RadioFrequency: '#FFF8E6',
  HotStone: '#FFF8E6',
  Moxibustion: '#FFF3F0',
};

const COLOR_TOOLTIP_BY_MASSAGE: Record<Massage.MassageItem, string> = {
  Shockwave: '#05f',
  Massage: '#BB66FC',
  RadioFrequency: '#FFA929',
  HotStone: '#FFA929',
  Moxibustion: '#FF614F',
};

const COLOR_ITEM_BY_MASSAGE: Record<Massage.MassageItem, string> = {
  Shockwave: '#5297FF',
  Massage: '#B9A3FD',
  RadioFrequency: '#FFBF52',
  HotStone: '#FFBF52',
  Moxibustion: '#FF857C',
};

export const getConsumptionOption = (data: GetMemberConsumptionInfoResponse[]): EChartsOption => {
  const seriesData = data?.map(item => {
    return {
      name: MassageType2Text[item.itemType],
      value: item.totalOrders,
      itemStyle: {
        color: COLOR_ITEM_BY_MASSAGE[item.itemType],
      },
      tooltip: {
        trigger: 'item',
        // eslint-disable-next-line fuxi/max-params-with-fixable
        position: function (pos, params, dom, rect, size) {
          if (pos[0] > rect.x + rect.width / 2) {
            if (pos[1] > rect.y + rect.height / 2) {
              return [pos[0], pos[1]];
            } else {
              return [pos[0], pos[1] - size.contentSize[1]];
            }
          } else {
            if (pos[1] > rect.y + rect.height / 2) {
              return [pos[0] - size.contentSize[0], pos[1]];
            } else {
              return [pos[0] - size.contentSize[0], pos[1] - size.contentSize[1]];
            }
          }
        },
        confine: true,
        borderColor: 'transparent',
        backgroundColor: BACKGROUND_COLOR_TOOLTIP_BY_MASSAGE[item.itemType],
        textStyle: {
          fontSize: px2vw(12),
          color: COLOR_TOOLTIP_BY_MASSAGE[item.itemType],
        },
        padding: [px2vw(4), px2vw(6)],
        borderRadius: px2vw(4),
        extraCssText: 'box-shadow: 0px -2.1px 16.8px 0px #00000008;',
        formatter: function (params: any) {
          const result = params.data.name + `<span style="margin-left: ${px2vw(8)}px;">${params.data.value}单</span>`;
          return result;
        },
      },
    };
  });

  return {
    textStyle: {
      fontFamily: 'OPlusSans 3.0,sans-serif',
    },
    tooltip: {
      show: true,
    },
    legend: {
      show: false,
    },
    series: [
      {
        name: '消费偏好',
        type: 'pie',
        colorBy: 'data',
        legendHoverLink: false,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        radius: ['70%', '100%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        emphasis: {
          disabled: true,
        },
        labelLine: {
          show: false,
        },
        data: seriesData,
      },
    ],
  };
};

const formatSeriesData = (data: GetMemberConsumptionInfoResponse[], type: Massage.MassageItem) => {
  const formatData = data
    ?.find(item => item.itemType === type)
    ?.dailyOrders?.map(item => {
      return {
        value: item,
        itemStyle: {
          color: COLOR_ITEM_BY_MASSAGE[type],
        },
      };
    });

  return formatData?.reverse();
};

export const getConsumptionTimesOption = (
  data: GetMemberConsumptionInfoResponse[],
  dataXAxis: string[]
): EChartsOption => {
  const legendData = data?.map(item => ({
    name: MassageType2Text[item.itemType],
    itemStyle: { color: COLOR_ITEM_BY_MASSAGE[item.itemType] },
  }));

  const dailyTotalOrders: number[] = Array(dataXAxis?.length).fill(0);

  data?.forEach(info => {
    info.dailyOrders.forEach((orders, index) => {
      dailyTotalOrders[index] += orders;
    });
  });

  let seriesData: EChartsOption['series'] =
    data?.map(item => ({
      name: MassageType2Text[item.itemType],
      type: 'bar',
      stack: 'Ad',
      legendHoverLink: false,
      barWidth: px2vw(26),
      z: 2,
      emphasis: {
        disabled: true,
      },
      data: formatSeriesData(data, item.itemType),
    })) || [];
  // 不显示 只是为了统计总数值
  seriesData.push({
    name: 'total',
    type: 'bar',
    stack: 'total',
    barWidth: px2vw(26),
    legendHoverLink: false,
    z: 1,
    emphasis: {
      disabled: true,
    },
    barGap: '-100%',
    label: {
      show: true,
      color: '#000000D9',
      fontSize: px2vw(14),
      fontWeight: 600,
      position: 'top',
      formatter: params => ((params.value as number) > 0 ? params.value + '单' : ''),
    },
    data: dailyTotalOrders
      ?.map(item => ({
        itemStyle: {
          color: 'transparent',
          borderRadius: [px2vw(4), px2vw(4), 0, 0],
        },
        value: item,
      }))
      .reverse(),
  });

  const filterSeriesData = seriesData?.filter(item => item.name !== 'total')?.reverse();
  // 设置柱条顶层圆角
  for (let i in filterSeriesData[0]?.data as any) {
    for (let item of filterSeriesData) {
      //遍历单根柱条
      //  找到第一个不为0的值，为该项添加itemStyle
      if (item?.data?.[i]?.value != 0) {
        // 找到第一个不为0的值，为该项添加itemStyle
        item.data[i]['itemStyle'] = {
          ...item?.data?.[i]['itemStyle'],
          borderRadius: [px2vw(4), px2vw(4), 0, 0],
        };
        break; //退出该柱条的循环
      }
    }
  }
  return {
    textStyle: {
      fontFamily: 'OPlusSans 3.0,sans-serif',
    },
    dataZoom: [
      {
        type: 'slider',
        show: dataXAxis?.length > 7 ? true : false,
        startValue: dataXAxis?.[0],
        endValue: dataXAxis?.[dataXAxis?.length - 1],
        minValueSpan: 6,
        maxValueSpan: 6,
        handleSize: 0,
        handleIcon: 'none',
        filterMode: 'none',
        showDetail: false,
        showDataShadow: false,
        backgroundColor: 'transparent',
        fillerColor: '#C2C7D166',
        borderColor: 'transparent',
        moveHandleSize: 0,
        zoomLock: true,
        brushSelect: false,
        height: px2vw(20),
        bottom: px2vw(6),
      },
      {
        type: 'inside',
        filterMode: 'none',
        throttle: 80,
        zoomLock: true,
        preventDefaultMouseMove: true,
        zoomOnMouseWheel: false,
        moveOnMouseMove: true,
        moveOnMouseWheel: true,
      },
    ],
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#FFFFFF',
      borderRadius: px2vw(8),
      textStyle: {
        color: '#262626',
        fontSize: px2vw(12),
      },
      extraCssText: `width:${px2vw(160)}px;box-shadow: 0px 2px 8px 0px #C4CAD47A;`,
      formatter: function (params: any) {
        const allValueNull = params.every(item => item.value === 0);

        if (allValueNull) {
          return;
        }
        let result = params[0].name;
        // 去除0和total的数据
        const newParams = klona(params)
          ?.reverse()
          ?.filter(item => item.seriesName !== 'total')
          .filter(item => item.value !== 0);

        newParams.forEach((item: any) => {
          result += `<div style="display:flex;justify-content: space-between;align-items: center;margin-top:8px;"><div style="display:flex;align-items: center"><div style="display:inline-block;margin-right:8px;border-radius:4px;width:12px;height:12px;background-color:${item.color};"></div><div>${item.seriesName}</div></div>
            <div style="font-weight:600;">${item.value}单</div></div>`;
        });

        const totalOrders = params?.filter(item => item.seriesName === 'total')?.[0]?.value;
        if (totalOrders !== 0) {
          result += `<div style="display:flex;justify-content: space-between;align-items: center;margin-top:8px;"><div style="display:flex;align-items: center"><div style="display:inline-block;margin-right:8px;border-radius:4px;width:12px;height:12px;background-color:#0055FF;"></div><div>总计</div></div>
          <div style="font-weight:600;">${totalOrders}单</div></div>`;
        }

        return result;
      },
    },
    legend: {
      data: legendData?.reverse(),
      top: 0,
      right: 0,
      itemWidth: px2vw(16),
      itemHeight: px2vw(16),
      itemGap: px2vw(32),
      borderRadius: px2vw(4),
      padding: [px2vw(2), px2vw(8), px2vw(2), 0],
      selectedMode: false,
      textStyle: {
        fontSize: px2vw(14),
        color: '#00000073',
        lineHeight: px2vw(22),
        padding: [0, 0, 0, px2vw(6)],
      },
    },
    grid: {
      top: px2vw(55),
      left: 0,
      right: 0,
      bottom: dataXAxis?.length > 7 ? px2vw(32) : px2vw(16),
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: dataXAxis,
      inverse: true,
      axisLabel: {
        color: '#000000D9',
        fontSize: px2vw(12),
        lineHeight: px2vw(20),
        formatter: value => {
          return formatDay(value);
        },
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          width: px2vw(1),
          color: '#0000000F',
        },
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#0000004D',
        fontSize: px2vw(12),
        lineHeight: px2vw(20),
      },
      splitLine: {
        lineStyle: {
          width: px2vw(1),
          color: '#0000000F',
        },
      },
      boundaryGap: [0, '12%'],
    },
    series: seriesData,
  };
};
